import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client';
import getConfig from 'next/config';

const cache = new InMemoryCache();
const { publicRuntimeConfig } = getConfig();
const link = new HttpLink({
    uri: `${publicRuntimeConfig.strapiUrl}/graphql`,
});
const client = new ApolloClient({
    ssrMode: typeof window === 'undefined',
    cache,
    link,
});

export default client;
